export default "__VITE_ASSET__BKqod5U7__"